import { SkyGoogleTagConfig } from './ga-tagging-config.types';

export const GA_SKY_TAGS_MOCK: SkyGoogleTagConfig = {
  checkoutSteps: {
    checkoutLanding: null,
    personalDetails: null,
    selectPayment: null,
    paymentDetails: null,
    quote: null,
    loggedIn: null,
    paymentDetailsSummary: null,
  },
  dimensions: {
    brandName: null,
    paymentType: null,
    companyCode: null,
    applianceName: null,
    applianceDetailsValues: null,
    excess: null,
    reference: null,
    coverType: null,
    paymentNumber: null,
    fee: null,
    schemeCode: null,
    purchaseMonth: 'dimension35',
    purchaseYear: 'dimension36',
    purchasePrice: 'metric4',
    lt: 'dimension34',
    ltPrice: 'metric3',
  },
  config: {
    showLegacyTags: false,
  },
  quoteLandingTags: {
    event: 'app.pageView',
    pagename: 'sky-box-selection',
    genericpagename: 'sky-box-selection',
    category: 'sky-mobile',
  },
  selectSkyBoxCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'SkyBoxSelectButton',
    eventAction: 'SelectedSkyQ',
    eventLabel: '',
  },
  applianceDetailsLandingTags: {
    event: 'app.pageView',
    pagename: 'add-device-page',
    genericpagename: 'sky-mobile-multiplan-builder',
    category: 'sky-mobile',
    BoxType: 'sky-q',
  },
  inclusionExclusionsData: {
    event: 'GAEvent',
    eventname: 'quote-tab',
    eventCategory: 'quote-summary',
    eventAction: 'quote tab clicked',
  },
  selectDeviceCategory: {
    event: 'GenericGAEvent',
    eventCategory: 'AddDevice',
    eventAction: 'FirstDeviceTypeSelected',
    eventLabel: 'Television',
  },
  addDeviceCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'AddDevice',
    eventAction: 'RemoveDevice',
    eventLabel: 'Television',
  },
  addLaterCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'AddDevice',
    eventAction: 'DeviceDetails',
    eventLabel: 'Add later',
  },
  addItemToBasket: {
    event: 'productAdd',
  },
  deleteItemFromBasket: {
    event: 'EEremoveFromCart',
  },
  basketLandingTags: {
    event: 'app.pageView',
    pagename: 'check-out-summary',
    genericpagename: 'sky-mobile-checkout',
    category: 'sky-mobile',
    BoxType: 'sky-classic',
    multiplanappliance: '1:Sky+HD £9|2:Playstation 3 Sony £0|',
  },
  productCheckoutData: {
    event: 'productCheckout',
  },
  checkoutSummaryCTA: {
    event: 'GenericGAEvent',
    eventCategory: 'CheckoutSummary',
    eventAction: 'Continue to Payment',
  },
  checkoutPersonalDetails: {
    event: 'app.pageView',
    pagename: 'personal-detail-page',
    genericpagename: 'sky-mobile-checkout',
    category: 'sky-mobile',
    BoxType: 'sky-classic',
    DeviceCost: '1:Sky +HD 9|2: Playstation 3 Sony 0',
    multiplanappliance: '1:Sky +HD 9|2:Playstation 3 Sony 0',
  },
  checkoutDirectDebitCommonData: {
    event: 'app.pageView',
    pagename: 'sky-mobile-payment',
    genericpagename: 'sky-mobile-checkout',
    category: 'sky-mobile',
    EmailAddress: 'provided',
  },
  onOrderConfirmationPageLoad: {
    event: 'app.pageView',
    pagename: 'sky-mobile-order-confirmation',
    genericpagename: 'order-confirmation',
    category: 'sky-mobile',
  },
};

export const E_ADD_ITEM_TAGS_MOCK = {
  // ecommerce: { ... }
};

export const E_DELETE_ITEM_TAGS_MOCK = {
  // ecommerce: { ... }
};

export const E_CHECKOUT_PRODUCTS_TAGS_MOCK = {
  // ecommerce: {
  //   checkout: {
  //     actionField: {
  //       step: 1
  //     },
  //     products: { ... }
  // }
};

export const E_PERSONAL_DETAILS_TAGS_MOCK = {
  ecommerce: {
    checkout: {
      actionField: {
        step: 2,
        action: 'checkout',
      },
    },
  },
};

export const E_DIRECT_DEBIT_TAGS_MOCK = {
  ecommerce: {
    checkout: {
      actionField: {
        step: 3,
        action: 'checkout',
      },
    },
  },
};
